import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CustomerCtx = createContext(null);

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(undefined); // undefined = checking, null = guest

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/customer/me");
      setCustomer(data);
      return data;
    } catch {
      setCustomer(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // Returning from Google: let the callback exchange the session first
    if (window.location.hash?.includes("session_id=")) {
      setCustomer(null);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try {
      await api.post("/customer/logout");
    } catch (err) {
      console.warn("Customer logout failed", err?.message);
    }
    setCustomer(null);
  };

  return <CustomerCtx.Provider value={{ customer, setCustomer, refresh, logout }}>{children}</CustomerCtx.Provider>;
}

export const useCustomer = () => useContext(CustomerCtx);

export function startGoogleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/compte";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
